import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DynamicCareerForm from '../components/layout/DynamicCareerForm';

const IsBasvurusuPage: React.FC = () => {
  return (
    <DynamicCareerForm />
  );
};

export default IsBasvurusuPage;
